import produce from 'immer';
import { ActionTypes } from './toasts.actions';
// import { ToastObject, ToastType } from './Toasts';

export const initialState = {
    success: [],
    info: [],
    warning: [],
    error: []
};
// if (process.env.NODE_ENV === 'development') {
//     initialState.success.push(new ToastObject({ type: ToastType.Success, message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer a nibh en.', dismiss: 0 }));
//     initialState.warning.push(new ToastObject({ type: ToastType.Warning, message: 'Aplikacja została zarchiwizowana', dismiss: 0 }));
//     initialState.error.push(new ToastObject({ type: ToastType.Error, message: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer a nibh enim. Praesent semper purus in condimentum feugiat. Sed consectetur gravida orci, ac iaculis ligula sagittis non. Praesent semper purus in condimentum feugiat.', dismiss: 0 }));
// }
const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.success: {
            draft.success.push(action.payload.toast);
            return draft;
        }
        case ActionTypes.warning: {
            draft.warning.push(action.payload.toast);
            return draft;
        }
        case ActionTypes.info: {
            draft.info.push(action.payload.toast);
            return draft;
        }
        case ActionTypes.error: {
            draft.error.push(action.payload.toast);
            return draft;
        }
        case ActionTypes.remove: {
            const { id, type } = action.payload;
            draft[`${type}`] = state[`${type}`].filter((toast) => toast.id !== id);
            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;
